import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20abstract%20geometric%20background%20with%20warm%20golden%20amber%20gradients%2C%20luxurious%20flowing%20curves%2C%20dark%20elegant%20texture%2C%20premium%20brand%20atmosphere%2C%20soft%20dramatic%20lighting%20with%20subtle%20particles%2C%20corporate%20sophisticated%20style%2C%20clean%20minimalist%20composition%2C%20deep%20charcoal%20and%20rich%20gold%20tones&width=1600&height=900&seq=kaiyun-hero-bg&orientation=landscape"
          alt="开云官网"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <div className="mb-3 inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
          <i className="ri-verified-badge-line text-primary-400 text-sm"></i>
          <span className="text-white/85 text-xs font-medium">{heroData.subtitle}</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-5 tracking-tight">
          {heroData.title}
        </h1>
        <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          {heroData.description}
        </p>
        <div className="flex items-center justify-center gap-3 mb-12 flex-wrap">
          <Link
            to="/about#contact"
            className="px-6 py-3 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            {heroData.ctaPrimary}
          </Link>
          <Link
            to="/about#contact"
            className="px-6 py-3 rounded-md border border-white/30 text-white text-sm font-semibold hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
          >
            {heroData.ctaSecondary}
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl mx-auto">
          {heroData.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading text-white mb-1">{stat.value}</div>
              <div className="text-white/55 text-xs md:text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}